export const defaultBindings = {
  service: 'banking-shopping-client',
};
